import { BmHttp } from "../utils/Global";

// RP-07: unica fuente de permisos RBAC efectivos del actor autenticado para
// el frontend -- nunca derivar permisos de nivel_user_id.
export const ObtenerMisPermisos = async () => {
  const { data } = await BmHttp().get("me/permissions");
  return data;
}
